<template>
  <div>
    <CRow class="mt-4">
      <CCol md="12">
        <CCard>
          <CCardHeader color="light" class="d-inline-flex justify-content-between align-items-center">
            <div>
              <i class="fa fa-tachometer"></i>
              <strong> Báo cáo thống kê </strong>
            </div>
            <!--            <small>theo chức vụ</small>-->
            <CButton color="primary" class="text-right" @click="loadDataStatistic()">
              <i class="fa fa-refresh"></i>&nbsp;Tải lại
            </CButton>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md="12">
                <CCard>
                  <CCardHeader color="light">
                    <i class="fa fa-desktop"></i>
                    <strong> Thiết bị <span v-if="statistic && statistic.devices">({{ statistic.devices.total }})</span></strong>
                  </CCardHeader>
                  <CCardBody class="row" v-if="statistic && statistic.devices">
                    <CCol md="3">
                      <CWidgetProgressIcon
                        :header="statistic.devices.totalConnect != null ? statistic.devices.totalConnect.toString() : '0'"
                        text="Đang kết nối"
                        :inverse="true"
                        color="gradient-success">
                        <i class="fa fa-rss"></i>
                        <div slot="progress">
                          <CProgress
                            :value="getPercentConnect"
                            :showPercentage="true"
                            :showValue="true"
                            color="secondary"
                            height="13px"
                            :striped="false"
                            :animated="true"
                            class="progress-xs progress-white my-3 mb-0"
                          />
                        </div>
                      </CWidgetProgressIcon>
                    </CCol>
                    <CCol md="3">
                      <CWidgetProgressIcon
                        :header="statistic.devices.totalDisconnect != null ? statistic.devices.totalDisconnect.toString() : '0'"
                        text="Mất kết nối"
                        :inverse="true"
                        color="gradient-danger">
                        <i class="fa fa-unlink"></i>
                        <template slot="progress">
                          <CProgress
                            :value="getPercentDisConnect"
                            class="progress-xs progress-white my-3 mb-0"
                            :showPercentage="true"
                            :showValue="true"
                            color="secondary"
                            height="13px"
                            :striped="false"
                            :animated="true"
                          />
                        </template>
                      </CWidgetProgressIcon>
                    </CCol>
                    <CCol md="3">
                      <CWidgetProgressIcon
                        :header="statistic.devices.totalActive != null ? statistic.devices.totalActive.toString() : '0'"
                        text="Đang hoạt động"
                        :inverse="true"
                        color="gradient-info">
                        <i class="fa fa-play"></i>
                        <template slot="progress">
                          <CProgress
                            :value="getPercentActive"
                            :showPercentage="true"
                            :showValue="true"
                            color="secondary"
                            height="13px"
                            :striped="false"
                            :animated="true"
                            class="progress-xs progress-white my-3 mb-0"
                          />
                        </template>
                      </CWidgetProgressIcon>
                    </CCol>
                    <CCol md="3">
                      <CWidgetProgressIcon
                        :header="statistic.devices.totalInactive != null ? statistic.devices.totalInactive.toString() : '0'"
                        text="Không hoạt động"
                        :inverse="true"
                        color="gradient-warning">
                        <i class="fa fa-stop-circle"></i>
                        <template slot="progress">
                          <CProgress
                            :value="getPercentInactive"
                            :showPercentage="true"
                            :showValue="true"
                            color="secondary"
                            height="13px"
                            :striped="false"
                            :animated="true"
                            class="progress-xs progress-white my-3 mb-0"
                          />
                        </template>
                      </CWidgetProgressIcon>
                    </CCol>
                  </CCardBody>
                </CCard>
                <CCard v-if="statistic && statistic.files">
                  <CCardHeader color="light">
                    <i class="fa fa-file"></i>
                    <strong> Bản tin biên tập </strong>
                  </CCardHeader>
                  <CCardBody>
                    <CRow>
                      <CCol sm="2">
                        <h6 id="traffic" class="card-title mb-2">Từ ngày - đến ngày</h6>
                        <DatePicker id="datepicker" v-model="dateRange" :model-config="dateRangeConfig"
                                    :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }" is-range class="datepicker">
                          <template v-slot="{ inputValue, inputEvents }">
                            <input
                              :value="inputValue.start + ' - ' + inputValue.end"
                              v-on="inputEvents.start"
                              class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                              readonly
                            />
                          </template>
                        </DatePicker>
                      </CCol>
                      <!--              <CCol sm="7" class="d-none d-md-block">-->
                      <!--                <CButtonGroup class="float-right mr-3">-->
                      <!--                  <CButton-->
                      <!--                    color="outline-secondary"-->
                      <!--                    v-for="(value, key) in ['Day', 'Month', 'Year']"-->
                      <!--                    :key="key"-->
                      <!--                    class="mx-0"-->
                      <!--                    :pressed="value === selected ? true : false"-->
                      <!--                    @click="selected = value">-->
                      <!--                    {{value}}-->
                      <!--                  </CButton>-->
                      <!--                </CButtonGroup>-->
                      <!--              </CCol>-->
                    </CRow>
                    <MainChart style="height:350px;margin-top:40px;"
                               :items="statistic.files"/>
                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseFormLoading from "@/views/base/BaseFormLoading";
import MainChart from "@/views/base/MainChart";
import {DatePicker} from "v-calendar";

export default {
  name: 'Dashboard',
  components: {MainChart, BaseFormLoading, DatePicker},
  data() {
    return {
      loading: {value: false},
      dateRange: {
        start: this.$helper.subtractNowDate(14).setHours(0, 0, 0, 0),
        end: new Date().setHours(23, 59, 59, 999)
      },
      dateRangeConfig: {
        start: {
          timeAdjust: '00:00:00',
        },
        end: {
          timeAdjust: '23:59:59',
        },
      },
      statistic: null
    }
  },
  created() {
  },
  mounted() {
    this.loadDataStatistic();
  },
  methods: {
    loadDataStatistic: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/dashboard/statistic",
        dataSubmit() {
          return {
            fromDate: that.$helper.formatDate(that.dateRange.start),
            toDate: that.$helper.formatDate(that.dateRange.end)
          }
        },
        isJsonContentType: false,
        ignoreDefaultData: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.statistic = response.data.data;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    getPercentConnect() {
      if (this.statistic && this.statistic.devices & this.statistic.devices.total && this.statistic.devices.totalConnect) {
        return this.statistic.devices.totalConnect / this.statistic.devices.total * 100;
      }
      else {
        return 0;
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    getPercentDisConnect() {
      if (this.statistic && this.statistic.devices && this.statistic.devices.total && this.statistic.devices.totalDisconnect) {
        return this.statistic.devices.totalDisconnect / this.statistic.devices.total * 100;
      }
      else {
        return 0;
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    getPercentActive() {
      if (this.statistic && this.statistic.devices && this.statistic.devices.totalActive && this.statistic.devices.total) {
        return this.statistic.devices.totalActive / this.statistic.devices.total * 100;
      }
      else {
        return 0;
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    getPercentInactive() {
      if (this.statistic && this.statistic.devices && this.statistic.devices.totalInactive && this.statistic.devices.total) {
        return this.statistic.devices.totalInactive / this.statistic.devices.total * 100;
      }
      else {
        return 0;
      }
    }
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataStatistic();
      } else {
        this.dateRange = {
          start: new Date().setHours(0, 0, 0, 0),
          end: new Date().setHours(23, 59, 59, 999)
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
